import React, { useState } from "react";
import logo from "../assets/logo.png";
import { TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { httpService } from "../httpService";
import { toast } from "react-toastify";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const postData = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { data, error } = await httpService.post("recoverpassword", {
      email,
    });

    if (data) {
      toast.success(data);
    }

    if (error) {
      toast.error(error);
    }
    setLoading(false);
  };
  return (
    <div>
      <div className="container mt-5">
        <div className="text-center mb-4">
          <img src={logo} alt="logo" height={100} />
        </div>
        <div className="d-flex justify-content-center">
          <div className="col-lg-4">
            <div className="text-center mb-4">
              <Typography variant="h5" fontWeight={700}>
                Recover my password
              </Typography>
            </div>
            <form onSubmit={postData}>
              <div className="mb-3">
                <TextField
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  label="Email Address"
                  type="email"
                />
              </div>
              <div>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  fullWidth
                  color="success"
                  loading={loading}
                >
                  Send Mail
                </LoadingButton>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
